import CircularProgress from "@/components/CircularProgress";
import useDOMEventListener from "@/hooks/useDOMEventListener";
import { iconSizes, strokeWidth } from "@/utils/iconProps";
import { themeColors } from "@/utils/themeColors";
import { ArrowUp, ArrowDown } from "lucide-react";
import { useCallback, useState } from "react";

const ScrollProgress = ({ style }: { style?: React.CSSProperties }) => {
    const [value, setValue] = useState(0);
    const [scrollUp, setScrollUp] = useState(false);

    const getScrollPercentage = useCallback(() => {
        const documentHeight = Math.max(
            document.body.scrollHeight,
            document.body.offsetHeight,
            document.documentElement.clientHeight,
            document.documentElement.scrollHeight,
            document.documentElement.offsetHeight
        );

        const viewportHeight = window.innerHeight;
        const maxScrollPosition = documentHeight - viewportHeight;
        const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
        const scrollPercentage = Math.min(Math.max((currentScrollPosition / maxScrollPosition) * 100, 0), 100);

        return scrollPercentage;
    }, []);

    useDOMEventListener({
        on: "scroll",
        handler: () => {
            const v = getScrollPercentage();
            setValue(v);
            setScrollUp(v > 50);
        },
    });

    const Component = scrollUp ? ArrowUp : ArrowDown;

    return (
        <div
            onClick={() =>
                window.scrollTo(
                    scrollUp ? { top: 0, behavior: "smooth" } : { top: document.body.scrollHeight, behavior: "smooth" }
                )
            }
            style={{
                cursor: "pointer",
                zIndex: 1300,
                ...style,
            }}
            data-testid="auto-id-2d1520d3-3daa-4c82-bc36-f2e4df49da2f">
            <CircularProgress
                value={value}
                size={"6rem"}
                thickness={3}
                bgColor={themeColors.neutral1}
                color={themeColors.primary}
                disableAnimation
                label={
                    <Component size={iconSizes.MD} strokeWidth={strokeWidth.bold} color={themeColors.neutralBlack} />
                }
            />
        </div>
    );
};

export default ScrollProgress;
